import React, { useState } from 'react'
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RitBlockButtons } from '../RitBlockButton';


const getTextColor = (color) => {
    const blackFontColorCriteria = new Set(['#ffffff', '#efeacb', '#fbf5c5', '#ffeb70', '#fffba2', '#dcf1bb'])
    if (blackFontColorCriteria.has(String.prototype.toLocaleLowerCase.call(color))) {
        return 'black';
    }
    return 'white';
}

const StyledText = styled.p`
    color: ${props => getTextColor(props.background)};
`;

const ColorComponent = (options) => {
    let type = null
    if (options.meta.valid) {
        type = "success"
    } else if (options.meta.visited) {
        type = "error"
    }

    const [activeEnum, setactiveEnum] = useState(options.input.value);

    const onChange = (value) => {
        setactiveEnum(value);
        options.input.onChange(value)
    }

    return (
        <div className='b-rit-form-group' label={options.label}>
            <p className='b-rit-form-group__title'>{options.displayName}</p>
            <div className='b-rit-list'>
                {options.values.map((item, i) => {
                    return (
                        <RitBlockButtons
                            key={i}
                            value={item.attrValue}
                            checked={item.attrValue == activeEnum}
                            onChange={onChange}
                            themeClass={'item-theme--threads'}
                            style={{ background: item.objectId }}
                        >
                            <StyledText background={item.objectId}>
                                {item.shortName}
                            </StyledText>
                        </RitBlockButtons>
                    )
                })}
            </div>
        </div>
    )
}

ColorComponent.propTypes = {
    values: PropTypes.array.isRequired,
    displayName: PropTypes.string,
    label: PropTypes.string,
    input: PropTypes.object.isRequired,
}

export default ColorComponent;
